<template>
  <div
    class="video-container"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    v-if="isVideoLoaded"
  >
    <video
      v-if="isVideoLoaded"
      v-once
      id="my-video"
      class="video-js h-100 w-100"
      crossorigin="anonymous"
      preload="auto"
      width="640"
      height="264"
      :src="video_url"
      ref="videoRef"
      @play="handleVideoPlay"
      @loadeddata="handleVideoLoaded"
    ></video>
    <div class="video-control">
      <button
        class="btn btn-sm text-white"
        @click.prevent="playPause"
      >
        <i
          class="fas"
          :class="{ 'fa-pause': isPlaying, 'fa-play': !isPlaying }"
        ></i>
      </button>
      <button
        class="btn btn-sm text-white"
        @click.prevent="toggleMute"
      >
        <i
          class="fas"
          :class="{ 'fa-volume-up': !muted, 'fa-volume-mute': muted }"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-player',
  props: {
    video_url: {
      type: String,
      required: true,
    },
    is_autoplay: {
        type: Boolean,
        required: false,
        default: true,
    }
  },
  data() {
    return {
      videoRef: null,
      muted: false,
      isPlaying: false,
      showControls: false,
      isVideoLoaded: false,
    };
  },
  mounted() {
    this.videoRef = this.$refs.videoRef;
    this.isVideoLoaded = true;
  },
  methods: {
    playPause() {
      if (this.isPlaying) {
        this.videoRef.pause();
      } else {
        this.pauseOtherVideos();
        this.videoRef.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    pauseOtherVideos() {
      const allVideos = document.querySelectorAll('video');
      allVideos.forEach((video) => {
        if (video !== this.videoRef) {
          video.pause();
          video.isPlaying = false;
        }
      });
    },
    toggleMute() {
      this.videoRef.muted = !this.videoRef.muted;
      this.muted = this.videoRef.muted;
    },
    handleMouseEnter() {
      
      if (this.videoRef == null || this.videoRef == this.video) {
        this.videoRef = this.$refs.videoRef;
      }

      if(this.is_autoplay){
        this.videoRef.play();
        this.isPlaying = true;
        this.pauseOtherVideos();
      }
      else{
        this.videoRef.pause();
        this.isPlaying = false;
      }
    },
    handleMouseLeave() {

      this.videoRef.pause();
      this.isPlaying = false;
    },
    handleVideoPlay() {
      this.pauseOtherVideos();
    },
    handleVideoLoaded() {
      this.isVideoLoaded = true;
    },
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  overflow: hidden;
  height: 500px;
  width: 100%;
  border-radius: 10px;
}

.video-container video {
  object-fit: cover;
}

.video-control {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
  border-radius: 0 0 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: opacity 0.3s;

  button {
    font-size: 16px;
  }
}

.video-control:hover {
  opacity: 1;
}
</style>
